import {Injectable} from '@angular/core';
import {CanActivate, Router, UrlTree} from '@angular/router';
import {OAuthService} from 'angular-oauth2-oidc';
import {Observable} from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class AuthGuard implements CanActivate {
	constructor(private oauthService: OAuthService, private router: Router) {
	}

	canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		if (!this.oauthService.hasValidAccessToken()) {
			console.error(`auth.guard before logout`);	
			// this.oauthService.logOut();
			console.error(`auth.guard after logout`);	
			// this.router.navigate(['/authentication']);
			// window.location.href = '/authentication';
			console.error(`auth.guard after navigate to authentication`);				
			this.oauthService.loadDiscoveryDocumentAndLogin();
			console.error(`auth.guard after loadDiscoveryDocumentAndLogin`);	
			// this.oauthService.setupAutomaticSilentRefresh();
			console.error(`auth.guard after setupAutomaticSilentRefresh`);	
			if (!this.oauthService.hasValidAccessToken()) {
				return false;
			}
			return true;
		}
		return true;
	}
}
